<template>
  <div class="view pa24">
    <el-button type="primary" @click="add_tap">{{ $t('addedServices', 'newPosterModule') }}</el-button>
    <commonTable :tableData="tableData"
                 @handleSizeChange="handleSizeChange"
                 @handleCurrentChange="handleCurrentChange"
                 :currentPage="currentPage"
                 :loading="loading"
                 :total="total">
      <template v-slot:table>
        <el-table-column align="center" type="index" width="50" :label="$t('addedServices', 'serialNumber')"> </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          :label="$t('addedServices', 'posterModuleTitle')"
          show-overflow-tooltip
        />
        <el-table-column prop="images" align="center" :label="$t('addedServices', 'icon')">
        <template slot-scope="scope">
          <el-image
                  style="width: 36px;height:36px"
                  :src="scope.row.logo"
                  :preview-src-list="scope.row.imagesList">
          </el-image>
        </template>
        </el-table-column>
        <el-table-column prop="note" align="center" :label="$t('addedServices', 'imageCount')" />
        <el-table-column align="center" :label="$t('addedServices', 'operation')">
          <template slot-scope="scope">
            <el-button type="text" @click="detall_tap(scope.row,1)">{{ $t('addedServices', 'edit') }}</el-button>
            <el-button type="text" @click="detall_tap(scope.row,0)">{{ $t('addedServices', 'detail') }}</el-button>
            <el-button type="text" @click="delete_tap(scope.row)">{{ $t('addedServices', 'delete') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import i18nMixin from '@/mixins/i18nMixin';
import {
  queryPagePoster,
  deletePoster
} from "@/api/addedServices";
export default {
  mixins: [i18nMixin],
  data() {
    return {
      tableData:[],
      loading:'',
      currentPage: 1, //当前页数
      total: 0, //总条数
      pageNum:1,
      pageSize:10,
    };
  },
  components: {
    commonTable,
  },
  created(){
    this.getTableData()
  },
  methods:{
    async getTableData() {
      this.loading = true
      let data = {
        pageNum: this.pageNum,
        pageSize:this.pageSize,
      };
      const result = await queryPagePoster(data);
      this.loading = false
      if(result.data){
        this.tableData = result.data.pageInfo.list;
        this.total = result.data.pageInfo.total
        this.tableData.forEach(v=>{
          v.imagesList = [];
          v.imagesList.push(v.logo);
        })
      }else{
        this.tableData = []
      }
    },
    add_tap(){
      this.$router.push('/posterAtlasDetall')
    },
    detall_tap(row,type){
      this.$router.push({ path:`/posterAtlasDetall?classificationId=${(row == 1 ? '' :  row.classificationId)}&type=${type}` });
    },
    edit_tap(){

    },
    delete_tap(row){
      this.$confirm(this.$t('addedServices', 'confirmDeletePoster'), this.$t('addedServices', 'tip'), {
        confirmButtonText: this.$t('addedServices', 'confirm'),
        cancelButtonText: this.$t('addedServices', 'cancel'),
        type: "info ",
      })
      .then(() => {
        deletePoster(row)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: "success",
              message: this.$t('addedServices', 'operationSuccess'),
            });
            this.getTableData()
          }
        })
        
      })
      .catch((err) => {});
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getTableData();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.getTableData();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>